(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const group = document.activeElement?.closest('.cc-header details[open]');
  if (group) { group.open = false; group.querySelector('summary')?.focus(); }
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.cc-nav-group[open]').forEach((group) => { if (!group.contains(event.target)) group.open = false; });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-hero-slider"] && !Shopify.designMode) return;
  try {
    
  const initializeHero = (root) => {
    customElements.whenDefined('slideshow-component').then(() => {
      const tracks = root.querySelectorAll('.cc-hero-track');
      tracks.forEach((track) => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) track.pause();
      });
    });
  };
  initializeHero(document);
  document.addEventListener('shopify:section:load', (event) => initializeHero(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const track = event.target.closest('.cc-hero-track');
    if (!track) return;
    track.pause();
    track.select({ id: event.detail.blockId }, undefined, { animate: false });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
